import { Record } from 'immutable';
export default Record({
  recipientId: null,
  recipientType: null
}, 'RecipientLocator');